import React, { FC, ReactElement } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactElement | ReactElement[];
}

const ArticleBlockAside: FC<IProps> = ({ children }) => {
  return <aside className={css.articleBlock__aside}>{children}</aside>;
};

export default ArticleBlockAside;
